import React, {Component} from 'react'
import {connect} from 'react-redux'
import {actions as cartActions} from '../../../redux/modules/Cart'
import {bindActionCreators} from 'redux'
import PaymentPage from './PaymentPage'
import SostaOnlineApiService from '../../../services/SostaOnlineApiService'
import Loading from '../../../components/LoadingComponent'
import MarkPayment from './MarkPayment'
import AdjustmentPayment from './AdjustmentPayment'
import {Table} from "react-bootstrap";

const mapStateToProps = (state) => {
  return {
    cart: state.cart
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    cartActions: bindActionCreators(cartActions, dispatch)
  }
}

class WaitingListParkTicketPayment extends Component {
  constructor (props) {
    super(props)

    this.state = {
      paymentData: null,
      waitingList: {},
      loading: true
    }

    this.onPayClick = this.onPayClick.bind(this)
  }

  fetchWaitingList = async () => {
    const { match } = this.props
    const { params } = match
    const { id } = params
    const data = await SostaOnlineApiService.fetchUserWaitingList(id)
    this.setState({waitingList: data.data})
  }

  async componentDidMount () {
    this.setState({loading: true})
    await this.fetchWaitingList()
    this.setState({loading: false})
  }

  onPayClick  = () => {
    SostaOnlineApiService.buyWaitingListParkTicket(this.props.match.params.id).then(data => {
      this.setState({
        paymentData: data.data
      })
      window.location.href = 'https://ecomm.sella.it/pagam/pagam.aspx?a=' + this.state.paymentData.shopLogin + '&b=' + this.state.paymentData.cryptedString
    })
  }

  render () {
    const {waitingList} = this.state
    if (this.state.loading) {
      return (<Loading />)
    }

    return (
      <div className="col-md-offset-1 col-md-10">
        <div className="panel panel-default panel-border">
          <div className="panel-body">
            <h2 className="title">Riepilogo</h2>

            <div className="row">
              <div className="col-md-12 hidden-md hidden-lg">
                <div className="card-marks">
                  <div className="capiton cart-caption">
                    <div className="col-md-4">
                      <h4>
                      <span className="text-left">
                        {waitingList.parkTicketType && waitingList.parkTicketType.name}
                      </span>
                      </h4>
                    </div>

                    <div className="col-md-4">
                      <h4>
                        <strong>Prezzo </strong>
                        <span className="text-left">
                        € {Number(waitingList.Subscriptions[0].price).toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                      </span>
                      </h4>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <Table responsive className="hidden-xs hidden-sm">
              <thead>
              <tr>
                <th>Prodotto</th>
                <th>Prezzo</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td className="text-left">
                  <span>
                    {waitingList.parkTicketType && waitingList.parkTicketType.name}
                  </span>
                </td>
                <td className="text-left">
                  € {Number(waitingList.Subscriptions[0].price).toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                </td>
              </tr>
              </tbody>
            </Table>

            <div className="row">
              <div className="text-center">
                <h3>Totale: € {Number(waitingList.Subscriptions[0].price).toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</h3>
              </div>
            </div>

            <button onClick={this.onPayClick} type="button" className="btn btn-green">
              Acquista
            </button>

          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WaitingListParkTicketPayment)



// WEBPACK FOOTER //
// ./src/containers/UserArea/Checkout/WaitingListParkTicketPayment.js